import APIConstants from "common/constants/APIConstants";

const sanitizeURL = (url) => {
  let result = url;
  if (url.endsWith("/")) {
    result = url.slice(0, url.length - 1);
  }
  return result;
};

const generateHeaders = (authConfig, requestHeaders, isFormData) => {
  const headers = new Headers();
  if (authConfig) {
    headers.append("session", authConfig.sessionId);
    headers.append("Authorization", `Bearer ${authConfig.accessToken}`);
  }
  if (!isFormData) {
    headers.append("Content-Type", "application/json");
  }
  Object.keys(headers).forEach((key) =>
    headers.append(key, requestHeaders[key])
  );
  return headers;
};

const checkAuthentication = (response, checkAuth) => {
  if (checkAuth && response.status === 401) {
    window.sessionStorage.clear();
    window.location.reload();
  }
  return response;
};

const errorResponses = [400, 401, 403, 404, 500, 415];

async function checkError(response) {
  if (errorResponses.includes(response.status)) {
    throw await response.json();
  }
  return response;
}

export const api = async (
  {
    url = "",
    method = "GET",
    requestHeaders = {},
    params,
    body = null,
    isFormData = false,
    checkAuth = true
  },
  authConfig
) => {
  const headers = generateHeaders(authConfig, requestHeaders, isFormData);
  const paramString = new URLSearchParams(params).toString();
  const sanitizedURL = sanitizeURL(url);
  const requestURL = params ? `${sanitizedURL}?${paramString}` : sanitizedURL;
  let requestObject = { headers, method };
  if (body) {
    requestObject = {
      ...requestObject,
      body: isFormData ? body : JSON.stringify(body)
    };
  }
  return fetch(requestURL, requestObject)
    .then((response) => checkAuthentication(response, checkAuth))
    .then(checkError)
    .then((response) => response.json());
};

export const signupAction = async (formData) => {
  const { createUser } = APIConstants;
  return fetch(createUser, {
    method: "POST",
    body: formData
  })
    .then(checkError)
    .then((res) => res.json());
};
